import React from 'react';
import s from './custom-video-player.module.scss';
import { formatTime } from '../lib/format-time';

/** Нижний прогресс-бар: текущее время, буферизация, ползунок перемотки */
export const ProgressBar = ({ currentTime, duration, buffered, onSeek }) => {
	const progressPercent = duration ? (currentTime / duration) * 100 : 0;
	const bufferedPercent = duration ? (buffered / duration) * 100 : 0;

	return (
		<div className={s.bottomBar}>
			<span className={s.time}>{formatTime(currentTime)}</span>
			<div className={s.progressBarWrapper}>
				<div className={s.progressTrack}>
					<div className={s.progressBuffered} style={{ width: `${bufferedPercent}%` }} />
					<div className={s.progressFilled} style={{ width: `${progressPercent}%` }} />
				</div>
				<input
					type="range"
					min={0}
					max={100}
					step={0.1}
					value={progressPercent}
					onChange={onSeek}
					className={s.progressInput}
					aria-label="Прогресс видео"
				/>
			</div>
			<span className={s.time}>{formatTime(duration)}</span>
		</div>
	);
};
